import { Action } from 'redux'
import { createActions, createReducer } from 'reduxsauce'

import {
	IActionsFromCreators,
	IUserActionCreators
} from '../../interfaces/action'
import { IOAuthLoginResponse } from '../../services/auth.service'

/**
 * Action types & creators
 */
export const { Types, Creators }: IActionsFromCreators<IUserActionCreators> =
	createActions({
		setUser: ['user'],
		resetUser: []
	})

/**
 * Handlers
 */
export const INITIAL_STATE: IOAuthLoginResponse = {
	email: '',
	password: '',
	tipo_documento: '',
	documento: '',
	ins_estadual: '',
	ddi: '',
	ddd: '',
	telefone: '',
	cep: '',
	nome: '',
	endereco: '',
	complemento: '',
	bairro: '',
	cidade: '',
	numero: '',
	estado: '',
	pais: '',
	customer_id: '',
	perfil_cartao: '',
	perfil_id: '',
	perfil_quatro_ultimos: '',
	perfil_expiracao: '',
	cobranca_pagamento: '',
	produto: ''
}

const set = (state = INITIAL_STATE, action: any) => action.user
const reset = (state = INITIAL_STATE, action: any) => INITIAL_STATE

/**
 * Reducer
 */
export default createReducer<IOAuthLoginResponse, Action<IUserActionCreators>>(
	INITIAL_STATE,
	{
		[Types.SET_USER]: set,
		[Types.RESET_USER]: reset
	}
)
